module.exports = __webpack_public_path__ + "img/diapositiva-10-2.6862fdec.jpg";